import React, { AnchorHTMLAttributes } from 'react';

import { ReactComponent as RightArrowIcon } from 'assets/arrow-right-thin.svg';

import styles from './Arrows.module.scss';

const ArrowLink: React.FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({ children, ...props }) => (
  <a className={styles.arrowLink} {...props}>
    {children}
    <RightArrowIcon />
  </a>
);

export default ArrowLink;
